export var schema = {
  title: "Motor Vehicle Windscreen",
  description: "Motor Vehicle Windscreen Claim Form",
  type: "object",
  properties: {
    incident: {
      type: "object",
      title: "Incident",
      required: ["insureddateloss","incidentAddress","incidentDescription"],
      properties: {
        insureddateloss: {
          type: "string",
          title: "Date and Time When Incident Occurred?",
          format: "date-time"
        },
        incidentAddress: {
          type: "string",
          title: "Address Where Incident Occurred?"
        },
        incidentLat: {
          type: "string",
          title: "Latitude"
        },
        incidentLong: {
          type: "string",
          title: "Longitude"
        },
        incidentDescription: {
          type: "string",
          title: "Description of What Occurred?"
        },
        incidentChipped: {
          type: "boolean",
          title: "Chipped"
        },
        incidentCrackedShattered: {
          type: "boolean",
          title: "Cracked or Shattered"
        }
      }
    },
    vehicleDetails: {
      type: "object",
      title: "Vehicle Details",
      required: ["vehicleMake","vehicleModel","vehicleYear","vehicleRegistration"],
      properties: {
        vehicleMake: {
          type: "string",
          title: "Vehicle Make"
        },
        vehicleModel: {
          type: "string",
          title: "Vehicle Model"
        },
        vehicleYear: {
          type: "string",
          title: "Vehicle Year"
        },
        vehicleRegistration: {
          type: "string",
          title: "Registration Number"
        },
        vehicleVinNumber: {
          type: "string",
          title: "VIN Number"
        },
        vehicleEngineNumber: {
          type: "string",
          title: "Engine Number"
        }
      }
    },
    attachments: {
      type: "object",
      title: "Attachments",
      description: `Please Attach Any of the Following Applicable Documents:
      - Invoice (if already replaced)
      - Photos of damaged glass`,
      properties: {
        attachmentsList: {
          title: "Attachments",
          type: "array",
          description: "File Names Should Not Have Any Round Brackets. ()",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      required: ["insuredaccepttc"],
      title: "Declaration",
      description: "I/we declare that to the best of my/our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept Terms and Conditions",
          description: "Tick Box to Accept Terms and Conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};

export var uiSchema = {
  incidentLat: {
    "ui:widget": "hidden"
  },
  incidentLong: {
    "ui:widget": "hidden"
  },
  incidentDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  }
};